import { ReactNode, useContext, useEffect } from "react"
import { GoogleAnaliticsContext } from "../contexts/GoogleAnaliticsContext"
import ReactGA from "react-ga4";
import { AppMainStateContext } from "../contexts/AppMainStateContext";

export const GoogleAnalyticsProvider = ({ children }: { children: ReactNode }) => {
    const { appStates } = useContext(AppMainStateContext);
    useEffect(() => {
        if (appStates.isCookiesAgreed === true) {
            ReactGA.initialize("G-VSPWJH94B2");
            // ReactGA.send({ hitType: "pageview", page: "/landingpage", title: "Landing Page" });
            // ReactGA.event({
            //     category: "your category",
            //     action: "your action"
            // });
        }
    }, [appStates.isCookiesAgreed])

    return (
        <GoogleAnaliticsContext.Provider value={{}}>
            {children}
        </GoogleAnaliticsContext.Provider>
    )
}
